<app-uni-page [parent]="this" pageTitle="In-Process: Ship Prep" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <!-- Last Scan Confirmation Card -->
    <div *ngIf="lastScanItem" class="mx-4 my-3 qb-detail-card qb-primary-tint p-4 shrink-0">
      <div class="font-semibold text-base mb-2 uppercase tracking-wide">Last Scan</div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-2">
          <div class="text-sm text-gray-500">Item ID</div>
          <div class="font-semibold">{{ lastScanItem.id }}</div>
        </div>
        <div class="col-span-2">
          <div class="text-sm text-gray-500">J/O #</div>
          <div class="font-semibold">{{ lastScanItem.joDetail?.joHeader?.id }}</div>
        </div>
        <div class="col-span-3">
          <div class="text-sm text-gray-500">Account</div>
          <div>{{ lastScanItem.joDetail?.joHeader?.account?.accountName }}</div>
        </div>
        <div class="col-span-2">
          <div class="text-sm text-gray-500">Ship Bin</div>
          <div class="font-semibold text-lg">{{ lastScanShipBin?.id }}</div>
        </div>
        <div class="col-span-3">
          <div class="text-sm text-gray-500">Exp. Ship Date</div>
          <div>{{ lastScanShipBin?.expectedShipDate | date:'MM/dd/yyyy' }}</div>
        </div>
      </div>
    </div>

    <!-- Error message -->
    <div *ngIf="scanErrorMessage" class="mx-4 mb-2 text-red-500 font-semibold">
      {{ scanErrorMessage }}
    </div>

    <!-- Pending Items Grid -->
    <div class="qb-panel-title mx-4">Pending Items</div>
    <div class="flex items-center gap-4 mx-4 mb-2">
      <div class="flex items-center">
        <p-checkbox [(ngModel)]="showBackordersOnly" inputId="showBackordersOnly" [binary]="true" (onChange)="onFilterChanged()"></p-checkbox>
        <label for="showBackordersOnly" class="ml-2">Show Backorders Only</label>
      </div>

      <p-floatlabel variant="in">
        <p-select
          [options]="refreshOptions"
          [(ngModel)]="refreshSeconds"
          (ngModelChange)="setupRefresh()"
          optionValue="refreshSeconds"
          optionLabel="name"
        />
        <label for="in_label">Refresh Page</label>
      </p-floatlabel>

      <div *ngIf="showRefreshIcon">
        <i class="fa-duotone fa-solid fa-arrows-rotate"></i>
      </div>
    </div>
    <app-ag-grid [gridOptions]="pendingGridOptions" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
